import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=84b9f038"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=84b9f038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports